export default __webpack_public_path__ + "static/brett-jordan-manual-8493a58a4d00d3f8ed8f75e2ee184226.jpg";